module.exports = __webpack_public_path__ + "static/media/DwnldComplete.2f9ce4ca.svg";